import createModelStore from "../../utils/createModelStore";
import Service from "../../services/Service";

/** @deprecated */
const services = createModelStore<Service.Model, "services">("services");

export default services;
